// TOP ブランド紹介(g26-p-top__about): 浮遊する2枚(B=中央/D=右下)のスクロール連動パララックス。
// 対象は [data-parallax] を持つ要素。値=振幅(px)。
// 枠(figure)は固定し、内側の img を scale で振幅ぶんはみ出させて translateY する
// 「画像の中身だけが動く」方式（ISSUE行8。参考 shinka-masumi.jp Concept より控えめな振幅）。
// SP は写真が小さく同じ振幅でも動きが大きく見えるため、data-parallax-sp があれば SP(〜840px)で優先。
// prefers-reduced-motion: reduce では無効化。

const SP_MQ = "(max-width: 840px)"; // CSS の --sp と一致

function initParallax(): void {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const targets = Array.from(
    document.querySelectorAll<HTMLElement>("[data-parallax]")
  )
    .map((el) => ({
      el,
      img: el.querySelector<HTMLElement>("img"),
      amp: parseFloat(el.dataset.parallax || "24") || 24,
      ampSp:
        el.dataset.parallaxSp !== undefined
          ? parseFloat(el.dataset.parallaxSp) || 0
          : null,
    }))
    .filter((t) => t.img !== null);
  if (!targets.length) return;

  let ticking = false;
  const update = (): void => {
    ticking = false;
    const vh = window.innerHeight;
    const isSp = window.matchMedia(SP_MQ).matches;
    for (const t of targets) {
      if (t.el.offsetParent === null) continue; // 非表示(SP の D 等)はスキップ
      const r = t.el.getBoundingClientRect();
      // 要素が下端から入る(0)→上端へ抜ける(1)。中央付近で 0。
      const p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
      const amp = isSp && t.ampSp !== null ? t.ampSp : t.amp;
      const y = (0.5 - p) * 2 * amp; // +amp..-amp（中央付近で 0）
      // 枠は固定し中の img だけを動かす。scale で上下 amp ぶんの余白を確保して枠外の露出を防ぐ
      //（+1px はサブピクセル丸めで枠端が透けないための保険）
      const s = r.height > 0 ? 1 + (2 * amp + 2) / r.height : 1;
      t.img!.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0) scale(${s.toFixed(4)})`;
    }
  };
  const onScroll = (): void => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  update();
}

document.addEventListener("DOMContentLoaded", initParallax);

export {};
